import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import HeroSection from './components/HeroSection';
import ProductShowcase from './components/ProductShowcase';
import WhatIsSection from './components/WhatIsSection';
import HotWedgeSection from './components/HotWedgeSection';
import ApplicationsSection from './components/ApplicationsSection';
import ComparisonTable from './components/ComparisonTable';
import HowToChoose from './components/HowToChoose';
import FaqSection from './components/FaqSection';
import HelpCta from './components/HelpCta';

export default function GeomembranaCategoryPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });

    document.title = 'Máquinas de Solda de Geomembrana PEAD | SoldaGeo Brasil';

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Máquinas de solda de geomembrana PEAD, PELBD e PVC para impermeabilização profissional. Equipamentos de cunha quente e extrusão para aterros sanitários, mineração, reservatórios e aquicultura. Distribuidor oficial no Brasil com suporte técnico especializado.'
      );
    }

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://soldageo.com.br/maquinas-de-solda-de-geomembrana');

    // Organization Schema
    const orgSchema = document.getElementById('org-schema');
    if (!orgSchema) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'org-schema';
      script.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'SoldaGeo Brasil',
        url: 'https://soldageo.com.br',
        logo: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,fit=crop,q=95/A0xVvobDbRIBrVE7/rapidgeo__2_-removebg-preview-reducido-d95gQJQOpJIwwOxp.png',
        description: 'Importadora e distribuidora de máquinas de solda para geomembrana no Brasil e Argentina.',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Rua Hipólito Gregório Pereira 127, Canasvieiras',
          addressLocality: 'Florianópolis',
          addressRegion: 'SC',
          addressCountry: 'BR',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+55 48 991802091',
          contactType: 'sales',
          areaServed: 'BR',
        },
        sameAs: [
          'https://www.facebook.com/share/17JUHvyQmW/',
          'https://www.instagram.com/soldageobrasil/',
        ],
      });
      document.head.appendChild(script);
    }

    // BreadcrumbList Schema
    const bcSchema = document.getElementById('bc-schema');
    if (bcSchema) bcSchema.remove();
    const bcScript = document.createElement('script');
    bcScript.type = 'application/ld+json';
    bcScript.id = 'bc-schema';
    bcScript.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Início',
          item: 'https://soldageo.com.br/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Máquinas de Solda de Geomembrana',
          item: 'https://soldageo.com.br/maquinas-de-solda-de-geomembrana',
        },
      ],
    });
    document.head.appendChild(bcScript);

    return () => {
      const s = document.getElementById('bc-schema');
      if (s) s.remove();
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.setAttribute('href', 'https://soldageo.com.br/');
    };
  }, []);

  return (
    <div className="min-h-screen font-sans bg-white">
      <Header />
      <main>
        {/* Breadcrumbs */}
        <nav className="bg-gray-100 border-b border-gray-200" aria-label="Breadcrumb">
          <div className="max-w-7xl mx-auto px-6 md:px-10 py-3 flex items-center gap-2 text-xs text-gray-400 uppercase tracking-wide">
            <Link to="/" className="hover:text-green-600 transition-colors cursor-pointer font-bold">Início</Link>
            <i className="ri-arrow-right-s-line text-gray-300" />
            <span className="text-gray-800 font-black" aria-current="page">Máquinas de Solda de Geomembrana</span>
          </div>
        </nav>

        <HeroSection />
        <ProductShowcase />
        <WhatIsSection />
        <HotWedgeSection />
        <ApplicationsSection />
        <ComparisonTable />
        <HowToChoose />
        <FaqSection />
        <HelpCta />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}